export default "__VITE_ASSET__D$Y77fZu__"